// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__tGaEL","form":"styles_form__W4D7B","input":"styles_input__u3wwf","button":"styles_button__1ZHR_"};